export const routes = {
  root: "/",
  home: "home",
  orders: "orders",
  orderDetails: "orders/:orderId",
  userManagement: "user-management",
};
